import LanguageIcon from '@mui/icons-material/Language'
import MailIcon from '@mui/icons-material/Mail'
import PhoneIcon from '@mui/icons-material/Phone'
import { Avatar, Box, Link, Typography } from '@mui/material'
import { color } from 'config/color'
import { FindUs } from './FindUs'
interface IProps {
  isAuthenticated?: boolean
}

export const ContactUsByEmail = ({
  isAuthenticated = true
}: IProps): JSX.Element => {
  return (
    <Box display='flex' flexDirection='column' flex={1}>
      <Typography mb={2} fontSize='22px' fontWeight='700' color={color.grey[900]}>
        How to Contact Us
      </Typography>
      <Box display="flex" bgcolor={color.grey[50]} p={3} alignItems="center" my={1}>
        <Avatar sx={{ bgcolor: color.background[100], p: 1 }} >
          <MailIcon sx={{ color: color.primary[700], fontSize: 30 }} />
        </Avatar>
        <Box ml={2}>
          <Typography fontSize={16} fontWeight={500}>Email</Typography>
          <Link href="mailto:ResidentSupport@NationwideEnergyPartners.com">
            ResidentSupport@NationwideEnergyPartners.com</Link>
        </Box>
      </Box>
      <Box bgcolor={color.grey[50]} p={3} alignItems="center" mb={1}>
        <Box display="flex">
          <Avatar sx={{ bgcolor: color.background[100], p: 1 }} >
            <PhoneIcon sx={{ color: color.primary[700], fontSize: 30 }} />
          </Avatar>
          <Box ml={2}>
            <Typography fontSize={16} fontWeight={500} mb={0.5}>Phone</Typography>
            <Link href="tel:877-818-2637">877-818-2637</Link> or <Link href="tel:614-918-2031">614-918-2031</Link>
          </Box>
        </Box>
        <Box alignItems="center" bgcolor={color.background[50]} p={2} mt={2}>
          <Typography color={color.grey[900]} fontSize="14px" fontWeight="400">
            The NEP Resident Support team is available 8:00 am to 6:00 pm EST, Monday through Friday. After-hours emergency support is available 24/7.
          </Typography>
        </Box>
      </Box>
      <Box display="flex" bgcolor={color.grey[50]} p={3} alignItems="center" my={1}>
        <Avatar sx={{ bgcolor: color.background[100], p: 1 }} >
          <LanguageIcon sx={{ color: color.primary[700], fontSize: 30 }} />
        </Avatar>
        <Box ml={2}>
          <Typography fontSize={16} fontWeight={500}>Website</Typography>
          <Link target="_blank" rel="noopener noreferrer" href="https://residents.nationwideenergypartners.com">https://residents.nationwideenergypartners.com</Link>
        </Box>
      </Box>
      <FindUs isAuthenticated={isAuthenticated} />
    </Box>
  )
}
